(() => {
  const cart = () => document.getElementById('AlfuzonCart');
  const cartUpdating = () => Boolean(document.querySelector('[data-at-line].at-busy, form[data-at-pending="true"]'));
  const releaseCart = () => {
    const drawer = cart();
    if (drawer?.open) drawer.close();
    document.body.classList.remove('at-cart-open');
  };
  const checkoutSelector = '.ap-checkout .sr-headless-checkout, #AlfuzonCart [name="checkout"], #AlfuzonCart .shiprocket-headless button';
  document.addEventListener('click', event => {
    const checkout = event.target.closest(checkoutSelector);
    if (!checkout) return;
    if (cartUpdating()) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    releaseCart();
  }, true);
  document.addEventListener('submit', event => {
    if (event.submitter?.name === 'checkout') releaseCart();
  }, true);
  const syncAvailability = scope => {
    scope.querySelectorAll('[data-at-product]').forEach(region => {
      const selected = region.querySelector('[data-at-variant]:checked');
      const checkout = region.querySelector('[data-ap-product-checkout]');
      if (checkout && selected) checkout.hidden = selected.dataset.available !== 'true';
    });
  };
  document.addEventListener('change', event => {
    if (event.target.matches('[data-at-variant]')) syncAvailability(document);
  });
  syncAvailability(document);
  document.addEventListener('shopify:section:load', event => syncAvailability(event.target));
  new MutationObserver(records => {
    if (!cart()?.open) return;
    const started = records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.id === 'fastrr-main-container' || node.id === 'headless-container')));
    if (started) releaseCart();
  }).observe(document.body, {childList: true});
})();
